<template>
	<div>
		<div class="data41">
			<div class="data41Til">{{list.data.menuTitle}}</div>
			<div class="data41Box">
				<div class="swiper-data41Box" :class="`swiper-data41Box${list.index}`" >
					<div class="swiper-wrapper">
						<div class="swiper-slide swiper-slideTwo" v-for="(itema,indexa) in list.data.imgs"
							:key="indexa">
							<img :src="itema" />
						</div>
					</div>
					<template v-if="!headerShow">
							<div class="swiper-hexin-prev"  :style="{
								left:`30px`,
								display:qhShow?activeIndex==0?'none':'block':'none'
							}" @click="prev()">
								<img src="@/assets/index/hxz.png" />
							</div>
							<div class="swiper-hexin-next" :style="{
								right:`30px`,
								display:qhShow?activeIndex==list.data.imgs.length-1?'none':'block':'none'
							}" @click="next()">
								<img src="@/assets/index/hxy.png" />
							</div>
						</template>
				</div>
			</div>
			<div class="data6LeftBox">
				<div class="data6LeftFor" v-for="(item,index) in list.data.content" :key="index">
					<div class="data6LeftForImg">
						<img :src="item.icon" />
					</div>
					<div class="data6LeftForName">
						{{item.title}}
					</div>
					<div class="data6LeftForCen">
						<div v-for="(itema,indexa) in item.desc">
							{{itema.text}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				qhShow:true,
				activeIndex: 0,
				// list:[
				// 	{
				// 		img:require('@/assets/product/page10/lc1.png')
				// 	},
				// 	{
				// 		img:require('@/assets/product/page10/lc2.png')
				// 	},
				// 	{
				// 		img:require('@/assets/product/page10/lc3.png')
				// 	},
				// ]
			}
		},
		mounted() {
			let t = this
			let name='.swiper-data41Box'+this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				slidesPerView: 1,
				allowTouchMove: this.list.data.imgs.length > 1 ? true : false,
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			this.$nextTick(function(){
				if(this.list.data.imgs.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.imgs.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.imgs.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data41 {
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 150px;

		.data41Til {
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 92px;
		}

		.data41Box {
			display: flex;
			align-items: center;
			overflow-x: auto;

			.data41BoxFor:not(:last-child) {
				margin-right: 30px;
			}

			.data41BoxFor {
				img {
					width: 375px;
					height: 375px;
					object-fit: cover;
				}
			}
		}
	}

	.swiper-data41Box {
		overflow: hidden;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
		img {
			width: 1200px;
			height: 600px;
			object-fit: cover;
		}
	}

	.data6LeftBox {
		margin-top: 31px;
		display: flex;
		flex-wrap: wrap;
		width: 100%;

		.data6LeftFor {
			width: calc(49% - 40px);
			padding: 0 20px;
			margin-bottom: 70px;

			.data6LeftForImg {
				margin-bottom: 42px;

				img {
					width: 70px;
					height: 70px;
				}
			}

			.data6LeftForName {
				margin-bottom: 32px;
				font-size: 26px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #000000;
			}

			.data6LeftForCen {
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 300;
				color: #000000;
				white-space: pre-line;
			}
		}
	}
	@media screen and (max-width:1200px) {
		.data41 {
			width: 100% !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;
	
			.data41Til {
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}
			.data41BoxFor {
				img {
					width: 100% !important;
					height: auto !important;
					object-fit: contain !important;
				}
			}
			.swiper-data41Box {
				overflow: hidden;
			
				img {
					width: 100% !important;
					height: auto !important;
					object-fit: contain !important;
				}
				.swiper-hexin-prev{
					display: block;
				}
				.swiper-hexin-next{
					display: block;
				}
				.swiper-hexin-prev {
					position: absolute;
					top: 50%;
					left: 250px;
					z-index: 99;
					width: 48px;
					height: 48px;
					cursor: pointer;
					img {
						width: 14px !important;
						height: 24px !important;
					}
				
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 100%;
					transform: translateY(-50%);
					transition: all 0.3s ease;
				}
				
				.swiper-hexin-next {
					transform: translateY(-50%);
					position: absolute;
					top: 50%;
					right: 250px;
					z-index: 99;
					width: 48px;
					height: 48px;
					border-radius: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					transition: all 0.3s ease;
					cursor: pointer;
					img {
						width: 14px !important;
						height: 24px !important;
					}
				}
			}
		}
		.data6LeftBox {
			margin-top: 20px !important;
			.data6LeftFor {
				margin-bottom: 20px !important;
		
				.data6LeftForImg {
					margin-bottom: 20px !important;
		
					img {
						width: 35px !important;
						height: 35px !important;
					}
				}
		
				.data6LeftForName {
					margin-bottom: 20px !important;
					font-size: 18px !important;
				}
		
				.data6LeftForCen {
					font-size: 14px !important;
				}
			}
		}
	}
</style>